module.exports = __webpack_public_path__ + "img/club.f5a5a88d.svg";